import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sailings-dates" }
const _hoisted_2 = { class: "sailings-dates__list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "top" }
const _hoisted_5 = { class: "date-text day" }
const _hoisted_6 = { class: "date-text weekday" }
const _hoisted_7 = { class: "date-text month" }

import { YYYYMMDD, DD, dayOfWeekName, fullDate, monthName } from "@/helpers/dateHelpers";
import { addDays, eachDayOfInterval, startOfToday } from "date-fns";
import { computed } from "vue";

interface Props {
    modelValue: Date;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SailingsDates',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const activeDate = computed({
    get(): Date {
        return props.modelValue;
    },
    set(date: Date) {
        emit("update:modelValue", date);
    },
});

const visibleDates = computed(() => {
    return eachDayOfInterval({
        start: addDays(startOfToday(), -1),
        end: addDays(startOfToday(), 5),
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleDates.value, (visibleDate, index) => {
        return (_openBlock(), _createElementBlock("li", {
          onClick: ($event: any) => (activeDate.value = visibleDate),
          key: index,
          class: _normalizeClass(["sailings-dates__date", { active: _unref(YYYYMMDD)(visibleDate) === _unref(YYYYMMDD)(activeDate.value) }])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(DD)(visibleDate)), 1),
            _createElementVNode("small", _hoisted_6, _toDisplayString(_unref(dayOfWeekName)(visibleDate, 3)), 1)
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(monthName)(visibleDate, 3)), 1)
        ], 10, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("h4", null, _toDisplayString(_unref(fullDate)(activeDate.value)), 1)
  ]))
}
}

})